import PageNotFound from '@/components/main/error/PageNotFound'
import Proposal from '@/components/Proposal'
import CardDetail from '@/components/quotes/CardDetail'
import Order from '@/components/order/Order'
import ContentProposal from '@/components/quotes/ContentProposal'
import OrderSummary from '@/components/order/OrderSummary'
import PageError from '@/components/main/error/PageError'
import PageErrorIquoteNotFound from '@/components/main/error/PageErrorIquoteNotFound'
import PageErrorIquoteNotAvailable from '@/components/main/error/PageErrorIquoteNotAvailable'
import B2bProposal from '@/components/B2bProposal'
import B2bLogin from '@/components/b2b/B2bLogin'
import B2bOffer from '@/components/b2b/B2bOffer'
import B2bConfirmation from '@/components/b2b/B2bConfirmation'
import B2bOfferProposal from '@/components/b2b/B2bOfferProposal'
import store from '@/store'

export default [
  {
    path: '/iquote/:iquoteId',
    component: Proposal,
    children: [
      {
        path: '',
        redirect: 'step1',
      },
      {
        path: 'step1',
        name: 'ContentProposal',
        component: ContentProposal,
        props: true,

        children: [
          {
            path: ':id',
            name: 'card-detail',
            component: CardDetail,
            props: true,
          },
        ],
      },
      {
        path: 'step3/:id',
        name: 'OrderSummary',
        component: OrderSummary,
        props: true,
      },
      {
        path: 'order',
        name: 'Order',
        component: Order,
        props: true,
      },
      {
        path: 'order-detail',
        name: 'OrderDetail',
        component: CardDetail,
        props: true,
      },
    ],
  },
  {
    path: '/:company',
    component: B2bProposal,
    children: [
      {
        path: '',
        redirect: 'login',
      },
      {
        path: 'login',
        name: 'B2bLogin',
        component: B2bLogin,
      },
      {
        path: ':iquoteId',
        component: B2bOfferProposal,
        children: [
          {
            path: '',
            redirect: 'aanbod',
          }, 
          {
            path: 'aanbod',
            name: 'B2bOffer',
            component: B2bOffer,
          }, 
          {
            beforeEnter(to, from, next) { 
              if (!store.getters.chosenQuoteId) next(`/${to.params.company}/${to.params.iquoteId}/aanbod`)
              else next()
            },
            path: 'bevestiging',
            name: 'B2bConfirmation',
            component: B2bConfirmation,
          }
        ]
      },
    
    ]
  },
  {
    path: '/error',
    name: '500',
    component: PageError,
    props: true,
  },
  {
    path: '/iquote-not-found',
    name: 'iquoteNotFound',
    component: PageErrorIquoteNotFound,
    props: true,
  },
  {
    path: '/iquote-not-available',
    name: 'iquoteNotAvailable',
    component: PageErrorIquoteNotAvailable,
    props: true,
  },
  {
    path: '/404',
    name: '404',
    component: PageNotFound,
    props: true,
  },
  {
    path: '*',
    component: PageNotFound,
  },
]

// to do
// const routerGuards = []